import { h } from 'preact'

import { IconComponentProps } from './index'

const ClockIcon = ({ width = 20, height = 20, color = 'currentColor', customClass = '' }: IconComponentProps) => (
  <svg width={width} height={height} viewBox='0 0 20 20' className={customClass}>
    <path d='M1.66699 9.99996C1.66699 5.39996 5.39199 1.66663 9.99199 1.66663C14.6003 1.66663 18.3337 5.39996 18.3337 9.99996C18.3337 14.6 14.6003 18.3333 9.99199 18.3333C5.39199 18.3333 1.66699 14.6 1.66699 9.99996ZM3.33366 9.99996C3.33366 13.6833 6.31699 16.6666 10.0003 16.6666C13.6837 16.6666 16.667 13.6833 16.667 9.99996C16.667 6.31663 13.6837 3.33329 10.0003 3.33329C6.31699 3.33329 3.33366 6.31663 3.33366 9.99996ZM9.16699 5.83329H10.417V10.2083L14.167 12.4333L13.542 13.4583L9.16699 10.8333V5.83329Z' fill={color} />
  </svg>
)

export default ClockIcon
